import React, { Fragment } from 'react'

import { Helmet } from 'react-helmet'

import HeaderMain from '../components/header-main'
import Componenttextimage from '../components/componenttextimage'
import Component3images from '../components/component3images'
import Componentfaq from '../components/componentfaq'
import FooterMain from '../components/footer-main'
import './company.css'

const Company = (props) => {
  return (
    <div className="company-container">
      <Helmet>
        <title>Arcobo — промышленные роботы в Казахстане и Узбекистане</title>
        <meta
          name="description"
          content="Внедряем промышленных роботов и готовим под ключ решения автоматизации для сварочных, механообрабатывающих, литейных, металлургических и сборочных производств."
        />
        <meta
          property="og:title"
          content="Arcobo — промышленные роботы в Казахстане и Узбекистане"
        />
        <meta
          property="og:description"
          content="Внедряем промышленных роботов и готовим под ключ решения автоматизации для сварочных, механообрабатывающих, литейных, металлургических и сборочных производств."
        />
        <meta
          property="og:image"
          content="https://arcobo.tech/og_image.png"
        />
        <meta property="og:type" content="website" />
        <meta
          name="twitter:title"
          content="Arcobo — промышленные роботы в Казахстане и Узбекистане"
        />
        <meta
          name="twitter:description"
          content="Внедряем промышленных роботов и готовим под ключ решения автоматизации для сварочных, механообрабатывающих, литейных, металлургических и сборочных производств."
        />
        <meta
          name="twitter:image"
          content="https://arcobo.tech/og_image.png"
        />
        <link
          rel="canonical"
          href="https://arcobo.tech/company"
        />
        <meta
          property="og:url"
          content="https://arcobo.tech/company"
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html:
              '{"@context":"https://schema.org","@type":"BreadcrumbList","itemListElement":[{"@type":"ListItem","position":1,"name":"Home","item":"https://arcobo.tech"},{"@type":"ListItem","position":2,"name":"Company","item":"https://arcobo.tech/company"}]}',
          }}
        />
      </Helmet>
      <HeaderMain rootClassName="header-mainroot-class-name19"></HeaderMain>
      <hr className="company-separator1"></hr>
      <Componenttextimage
        image1Src="/0_Main_page/main_00-1500w.webp"
        image1Alt="Промышленная роботизация Arcobo"
        rootClassName="componenttextimageroot-class-name9"
        textComponent={
          <Fragment>
            <span className="company-text10">
              <span>
                Arcobo – локальный интегратор промышленной роботизации в
                Казахстане и Центральной Азии
              </span>
              <br></br>
              <br></br>
              <span>
                Проектируем, производим, программируем и внедряем
                роботизированные комплексы под ключ для предприятий Казахстана и
                Центральной Азии.
              </span>
              <br></br>
              <br></br>
              <span>
                Arcobo – казахстанская инженерная компания, специализирующаяся
                на промышленной роботизации, автоматизации производственных
                процессов и WAAM-печати металлом. Мы реализуем проекты полного
                цикла: от анализа технологии и проектирования до запуска
                оборудования и сервисного сопровождения.
              </span>
            </span>
          </Fragment>
        }
        componentTitle="О компании"
      ></Componenttextimage>
      <Component3images
        image1Src="/Production/production_01-200h.webp"
        image1Alt="Производственная база Arcobo"
        image2Src="/Production/production_02-200h.webp"
        image2Alt="Производственная база Arcobo"
        image3Src="/Production/production_03-200h.webp"
        image3Alt="Производственная база Arcobo"
        rootClassName="component3imagesroot-class-name14"
      ></Component3images>
      <Component3images
        image1Src="/Production/production_11-200h.webp"
        image1Alt="Производственная база Arcobo"
        image2Src="/Production/production_12-200h.webp"
        image2Alt="Производственная база Arcobo"
        image3Src="/Production/production_13-200h.webp"
        image3Alt="Производственная база Arcobo"
        rootClassName="component3imagesroot-class-name15"
      ></Component3images>
      <Componentfaq
        answer1={
          <Fragment>
            <span className="company-text18">answer</span>
          </Fragment>
        }
        answer2={
          <Fragment>
            <span className="company-text19">answer</span>
          </Fragment>
        }
        answer3={
          <Fragment>
            <span className="company-text20">answer</span>
          </Fragment>
        }
        answer4={
          <Fragment>
            <span className="company-text21">answer</span>
          </Fragment>
        }
        answer5={
          <Fragment>
            <span className="company-text22">answer</span>
          </Fragment>
        }
        answer6={
          <Fragment>
            <span className="company-text23">answer</span>
          </Fragment>
        }
        answer7={
          <Fragment>
            <span className="company-text24">answer</span>
          </Fragment>
        }
        answer8={
          <Fragment>
            <span className="company-text25">answer</span>
          </Fragment>
        }
        showDiv
        showDiv1
        showDiv2
        showDiv3
        showDiv4
        showDiv5
        showDiv6
        showDiv7
        rootClassName="componentfaqroot-class-name8"
      ></Componentfaq>
      <hr className="company-separator2"></hr>
      <FooterMain rootClassName="footer-mainroot-class-name19"></FooterMain>
    </div>
  )
}

export default Company
